import { Sun, Eye, Moon, Pause, Sparkles } from "lucide-react";
import { useThemeMode } from "../context/ThemeContext";
import { theme } from "../theme";

const LABELS: Record<string, { icon: React.ReactNode; next: string }> = {
  dark:       { icon: <Sun size={14} />,  next: "Switch to light mode" },
  light:      { icon: <Eye size={14} />,  next: "Switch to colorblind-friendly mode" },
  colorblind: { icon: <Moon size={14} />, next: "Switch to dark mode" },
};

const toggleStyle: React.CSSProperties = {
  background: "var(--c-panel)",
  border: "1px solid var(--c-border)",
  borderRadius: 3,
  padding: "6px 10px",
  cursor: "pointer",
  fontSize: 14,
  lineHeight: 1,
  color: theme.color.muted,
  display: "flex",
  alignItems: "center",
  gap: 5,
};

/** Starts or stops the drifting background (components/BlueprintBackdrop.tsx); remembered per browser. */
export function MotionToggle() {
  const { motion, toggleMotion } = useThemeMode();
  const label = motion ? "Stop background motion" : "Start background motion";
  return (
    <button onClick={toggleMotion} title={label} aria-label={label} aria-pressed={motion} style={toggleStyle}>
      {motion ? <Pause size={14} /> : <Sparkles size={14} />}
    </button>
  );
}

export function ThemeToggle() {
  const { mode, cycle } = useThemeMode();
  const { icon, next } = LABELS[mode];

  return (
    <button
      onClick={cycle}
      title={next}
      aria-label={next}
      style={toggleStyle}
    >
      {icon}
    </button>
  );
}
